var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 509.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".el-1{fill:#032635}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "el-1",
    d: "M-5.74,486.23A12.75,12.75,0,0,0-18.49,499V612.2a38.3,38.3,0,0,1-38.26,38.25H-414.54a38.28,38.28,0,0,1-38.25-38.25V279.91a38.3,38.3,0,0,1,38.25-38.26h113.22a12.75,12.75,0,0,0,12.75-12.75,12.75,12.75,0,0,0-12.75-12.75H-414.54a63.83,63.83,0,0,0-63.76,63.76V612.2A63.83,63.83,0,0,0-414.54,676H-56.75A63.83,63.83,0,0,0,7,612.2V499A12.75,12.75,0,0,0-5.74,486.23Z",
    transform: "translate(478.3 -166.53)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "el-1",
    d: "M2,183.34a57.38,57.38,0,0,0-81.15,0l-227.5,227.49a12.89,12.89,0,0,0-3.27,5.62l-29.91,108a12.76,12.76,0,0,0,3.26,12.42,12.79,12.79,0,0,0,12.43,3.28l108-29.92a12.78,12.78,0,0,0,5.61-3.28L16.92,279.45a57.43,57.43,0,0,0,0-81.15ZM-278.9,419.12-92.72,232.93-32.67,293-218.86,479.17Zm-12,24.07,48,48-66.36,18.38ZM-1.11,261.42-14.63,275l-60-60.06,13.52-13.52a31.87,31.87,0,0,1,45.08,0l15,15A31.92,31.92,0,0,1-1.11,261.42Z",
    transform: "translate(478.3 -166.53)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f3bfafa1016effda1cc8c37b63a1a1ea.svg";
export { ForwardRef as ReactComponent };